import { Package, Gift } from 'lucide-react'

const INSULATED_BAG_IMAGE = 'http://dingtalk-aioa.oss-cn-zhangjiakou.aliyuncs.com/generated_images%2F20260321_145205_87b224fc.png?OSSAccessKeyId=LTAI5tEzpHuJTvr78D3mQewM&Expires=2089435925&Signature=c9oIHxuB6jqlCDUGNUKqN2AaPq8%3D'
const GIFT_BAG_IMAGE = 'http://dingtalk-aioa.oss-cn-zhangjiakou.aliyuncs.com/generated_images%2F20260321_145221_7ffe343a.png?OSSAccessKeyId=LTAI5tEzpHuJTvr78D3mQewM&Expires=2089435941&Signature=RbESv2%2F9Ip4KkrxRb9CimDsMjJQ%3D'

interface ProductCardProps {
  icon: React.ReactNode
  title: string
  description: string
  features: string[]
  image: string
}

function ProductCard({ icon, title, description, features, image }: ProductCardProps) {
  return (
    <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-apple-gray-200">
      <div className="aspect-square overflow-hidden bg-apple-gray-50">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="text-apple-gray-900">{icon}</div>
          <h3 className="text-2xl font-semibold text-apple-gray-900">{title}</h3>
        </div>
        <p className="text-apple-gray-600 mb-6 leading-relaxed">{description}</p>
        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-2 text-sm text-apple-gray-600">
              <span className="w-1.5 h-1.5 bg-apple-gray-900 rounded-full"></span>
              {feature}
            </li>
          ))}
        </ul>
        <a
          href="#quote"
          className="inline-flex items-center gap-2 text-apple-gray-900 font-medium text-sm hover:gap-3 transition-all"
        >
          Customize Now <Package size={16} />
        </a>
      </div>
    </div>
  )
}

function Products() {
  const products = [
    {
      icon: <Package size={28} />,
      title: 'Insulated Bags',
      description: 'Premium nonwoven insulated bags perfect for food delivery, grocery shopping, and temperature-sensitive items. Customizable sizes and printing options available.',
      features: [
        'Thermal insulation technology',
        'Eco-friendly nonwoven material',
        'Custom sizes and colors',
        'Logo printing available',
        'Durable and reusable',
      ],
      image: INSULATED_BAG_IMAGE,
    },
    {
      icon: <Gift size={28} />,
      title: 'Gift Bags',
      description: 'Elegant nonwoven gift bags ideal for retail packaging, events, and promotional purposes. Premium finish with various handle options.',
      features: [
        'Luxury appearance',
        'Multiple handle styles',
        'Custom dimensions',
        'Full-color printing',
        'Perfect for branding',
      ],
      image: GIFT_BAG_IMAGE,
    },
  ]

  return (
    <section id="products" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-semibold text-apple-gray-900 tracking-tight mb-4">
            Our Products
          </h2>
          <p className="text-lg text-apple-gray-600 max-w-2xl mx-auto">
            Discover our range of premium nonwoven bag solutions, designed for quality and customization
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {products.map((product, index) => (
            <ProductCard key={index} {...product} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Products
